export function closeForm ({ commit }) {
	commit(`closeForm`);
	commit(`vcl/overlay/close`, null, { root: true });
}
